export default {
  dashboard: {
    activetedCamera: 'dashboard.activetedCamera',
    deactivatedCamera: 'dashboard.deactivatedCamera',
    cahgedNickname: 'dashboard.cahgedNickname',
  },
};
